import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Typography } from '@material-ui/core';
import { connect } from 'react-redux';

import { toggleModal } from '../../actions/modal';
import Alert from './Alert';

const AppModal = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const actBtnRef = useRef();
  const { action, actionText, actionType } = props.actionButton;

  const onAction = async () => {
    setIsLoading(true);
    await action();
    if (props.closeAfterAction) {
      props.toggleModal();
    }
    setIsLoading(false);
  };

  return (
    <Modal
      isOpen={props.isOpen}
      toggle={props.toggleModal}
      className={props.className}
      style={{ minWidth: props.width }}
      centered={props.centered}
      zIndex={props.zIndex}
    >
      <Alert />
      <ModalHeader toggle={() => props.toggleModal()}>{props.title}</ModalHeader>
      <ModalBody>
        <Typography variant="body1">
          {props.content}
          {props.newLineContent && (
            <div style={{ marginTop: '1em' }}>
              {props.newLineContent}
            </div>
          )}
        </Typography>
      </ModalBody>
      <ModalFooter>
        {action && (
          <Button
            color={isLoading ? 'secondary' : actionType}
            onMouseDown={(e) => {
              e.preventDefault();
              onAction();
            }}
            style={{ minWidth: 100 }}
            ref={actBtnRef}
            disabled={isLoading}
          >
            {actionText}
          </Button>
        )}
        <Button color="secondary" onClick={() => props.toggleModal()} style={{ minWidth: 100 }}>
          {props.cancelText}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

AppModal.propTypes = {
  isOpen:       PropTypes.bool.isRequired,
  toggleModal:  PropTypes.func.isRequired,
  className:    PropTypes.string,
  zIndex:       PropTypes.number,
  actionButton: PropTypes.shape({
    actionText: PropTypes.string,
    actionType: PropTypes.string,
    action:     PropTypes.func,
  }),
  closeAfterAction: PropTypes.bool,
  title:            PropTypes.string,
  content:          PropTypes.string,
  newLineContent:   PropTypes.string,
  cancelText:       PropTypes.string,
  width:            PropTypes.string,
  centered:         PropTypes.bool,
};

AppModal.defaultProps = {
  className:        '',
  zIndex:           null,
  actionButton:     null,
  closeAfterAction: true,
  title:            '',
  content:          '',
  newLineContent:   null,
  cancelText:       'Cancel',
  width:            '400px',
  centered:         false,
};

const mapStateToProps = (state) => ({
  isOpen:           state.modal.status,
  title:            state.modal.title,
  className:        state.modal.className,
  content:          state.modal.content,
  newLineContent:   state.modal.newLineContent,
  actionButton:     state.modal.actionButton,
  cancelText:       state.modal.cancelText,
  closeAfterAction: state.modal.closeAfterAction,
  width:            state.modal.width,
  centered:         state.modal.centered,
  zIndex:           state.modal.zIndex,
});

export default connect(mapStateToProps, { toggleModal })(AppModal);
